export default {
  enquiryManagement: {
    label: {
      delivery: "Enquiries sent successfully",
      bounced: "Enquiries bounced",
      quarantined: "Enquiries quarantined",
    },
    filter: {
      agency: {
        name: "Agency",
      },
      branch: {
        name: "Branch",
      },
      agent: {
        name: "Agent",
      },
      developer: {
        name: "Developer",
      },
      enquiryType: {
        name: "Type",
        default: "Type",
        optionsTitle: "Types",
        selected: "Type",
      },
      interval: {
        name: "Time period",
        default: "Last 7 days",
        optionsTitle: "Last 7 days",
        selected: "Last 7 days",
      },
      status: {
        name: "Status",
        default: "Status",
        optionsTitle: "Status",
        selected: "Status",
      },
      clear: {
        short: "Clear",
        full: "Clear filters",
      },
      selected: "{selectedLength} filters applied",
      placeholder: "Last 7 days, all agencies, branches, agents",
      filter: "Filter",
    },
    noResult: {
      title: "No results",
      description: "Try adjusting your filters or try again later.",
      clearButton: "Clear all filters",
    },
    enquiryCount: {
      processedEnquiries: {
        tooltip:
          "This total represents all enquiries received by our enquiry service from the enquiry forms across iProperty.com.my.",
        title: "Total enquiries processed",
      },
      sentSuccessEnquiries: {
        tooltip:
          "These enquiries have been successfully delivered by our enquiry service and received by the recipient.",
        title: "Enquiries sent successfully",
      },
      bouncedEnquiries: {
        tooltip:
          "These enquiries have been sent by our enquiry service but were unable to be delivered successfully to all recipients due to a failure with the recipient's email service. This may be caused by their inbox being full or their email account being terminated.",
        title: "Enquiries bounced",
      },
      quarantinedEnquiries: {
        tooltip:
          "These enquiries have been blocked by our spam service due to breaching our spam rules. The enquiries have not been sent to the agent by our enquiry service. Further details of emails quarantined can be found below.",
        title: "Enquiries quarantined",
      },
    },
    quarantinedEmails: {
      emails: {
        tooltip:
          "These enquiries have been quarantined due to the enquirer email being included in the spam blacklist.",
        title: "Emails",
      },
      ipAddresses: {
        tooltip:
          "These enquiries have been quarantined due to the enquirer IP address being included in the spam blacklist.",
        title: "IP addresses",
      },
      urls: {
        tooltip:
          "These enquiries have been quarantined due to the enquiry text containing a URL which does not relate to iProperty.com.my.",
        title: "URLs",
      },
      words: {
        tooltip:
          "These enquiries have been quarantined due to the enquiry text contained a blacklisted word or phrase.",
        title: "Words and phrases",
      },
      rateLimits: {
        tooltip:
          "These enquiries have been quarantined as the enquirer has exceeded the allowed rate limit for enquiries within the time period.",
        title: "Rate limits",
      },
    },
    searchPlaceholder: "Search by keyword",
    enquiryTraffic: "Enquiry traffic",
    enquiries: "Enquiries",
    returnToTop: "Return to the top",
    noEnquiries: "We couldn't find anything matching your search",
    showing: "showing ",
    totalNumber: " results of {totalCount} total enquiries",
    enquiryDetail: "Enquiry detail",
    status: "Status: ",
    sentTo: "Sent to: ",
    quarantinedRule: "Quarantined rule: ",
    from: "From: ",
    date: "Date: ",
    to: "To: ",
    listingId: "Listing ID: ",
    name: "Name: ",
    enquiryType: "Enquiry type: ",
    message: "Message: ",
    block: "Blacklist",
    resend: "Resend",
    forward: "Forward",
    release: "Release",
    add: "Add ",
    blockEmail: " to email blacklist",
    blockCommand: {
      success: "Email address successfully added to the email blacklist.",
      existsFail: "Email address already exists in the email blacklist.",
      otherFail: "Email address could not be added in the email blacklist.",
    },
    releaseCommand: {
      success: "Enquiry successfully released from quarantine.",
      fail: "Enquiry could not be released from quarantine.",
    },
    resendCommand: {
      success: "Enquiry successfully resent to selected recipients.",
      fail: "Enquiry could not be resent to selected recipients.",
    },
    forwardCommand: {
      success: "Enquiry successfully forwarded to new recipient.",
      fail: "Enquiry could not be forwarded to new recipient.",
    },
    confirm: "Confirm",
    releaseEnquiry: "Release enquiry?",
    ResendFooterTitle: "Select email to resend to",
    forwardTo: "Forward to:",
    resendTo: "Resend to ",
    send: "Send",
    invalidFormat: "Invalid email format",
    enquiryIntervals: {
      title: "Enquiry interval",
      intervalsContent:
        "Set a limit to prevent a user sending more than one enquiry in a specific time interval",
      interval: "Interval",
      tooltipPart:
        "This helps to limit how quickly a user can send enquiries to a recipient using our forms, reducing instances where the recipient is spammed with multiple enquiries. The interval time sets the duration between a user sending the first and second enquiry. If the second enquiry is within the internal period it will be quarantined. The interval limit can be assigned to the user's IP address or the email and phone number submitted in the enquiry. If the interval is exceeded, the initial enquiry will be sent however each further enquiry submitted within the interval will be quarantined.",
      timeFilter: {
        name: "Time",
        default: "45 secs",
        optionsTitle: "45 secs",
        selected: "45 secs",
      },
    },
    enquiryRateLimit: {
      title: "Enquiry rate limit",
      rateLimit: "Rate limit",
      rateLimitContent:
        "Set a limit on the number of enquiries a user can send in a given period",
      timePeriod: "Time period",
      tooltipPart:
        "This helps limit how many enquiries a user can send to a recipient in a set time period, reducing instances where they are spammed with multiple enquiries. The rate limit sets the number of allowed enquiries in a selected time period. If a user exceeds the set enquiry amount within the time period, any future enquiries will be quarantined. The enquiry count is calculated using a rolling count based on the time period selected. When the user's enquiry count in a previous time period drops below a set limit, further enquiries are enabled. The rate limit can be assigned to the user's IP address or the email and phone number submitted in the enquiry.",
      countFilter: {
        name: "Enquiries",
        default: "15",
        optionsTitle: "15",
        selected: "15",
      },
      timeFilter: {
        name: "Time",
        default: "30 mins",
        optionsTitle: "30 mins",
        selected: "30 mins",
      },
    },
    email: "Email",
    ipAddress: "IP address",
    phoneNumber: "Phone number",
    time: "Time",
    on: "On",
    off: "Off",
    sortBy: "Sort: ",
    sortContent: {
      contentAsc: "A - Z",
      contentDesc: "Z - A",
      dateAsc: "Oldest to newest",
      dateDesc: "Newest to oldest",
    },
    blacklist: {
      remove: {
        ok: "Yes, remove",
        cancel: "Cancel",
      },
      add: "Add",
      date: "Date",
      action: "Action",
      EMAIL: {
        title: "Email addresses",
        tableTitle: "Email",
        removeTitle:
          "Are you sure you want to remove this email from the blacklist?",
        errorMsg:
          "The email address is not valid. Please make sure it is correct.",
        createNotify: "Email address successfully added to the blacklist.",
        removeNotify: "Email address successfully removed from blacklist.",
        duplicationNotify: "The email address already exists on the blacklist.",
        description:
          "The following blacklist will quarantine any enquiry which contains one of the following email addresses.",
        add: "Add an email",
        createTitle: "Add an email to blacklist",
        inputDescription: "Email",
        placeholder: "Enter email",
        confirmCreate: "Add",
      },
      WORD: {
        title: "Words and phrases",
        tableTitle: "Words and phrases",
        removeTitle:
          "Are you sure you want to remove this word or phrase from the blacklist?",
        errorMsg: "The word or phrase already exists on the blacklist.",
        createNotify: "Word or phrase successfully added to the blacklist.",
        removeNotify: "Word or phrase successfully removed from the blacklist.",
        duplicationNotify:
          "The word or phrase already exists on the blacklist.",
        description:
          "The following blacklist will quarantine any enquiry which includes an inappropriate word or phrase which has been included in the blacklist.",
        add: "Add a word or phrase",
        createTitle: "Add a word or phrase to blacklist",
        inputDescription: "Word or phrase",
        placeholder: "Enter word or phrase",
        confirmCreate: "Add",
      },
      IP: {
        title: "IP addresses",
        tableTitle: "IP addresses",
        removeTitle:
          "Are you sure you want to remove this IP address from the blacklist?",
        errorMsg:
          "The IP address is not valid. Please make sure it is correct.",
        createNotify: "IP address successfully added to the blacklist.",
        removeNotify: "IP address successfully removed from the blacklist.",
        duplicationNotify: "The IP address already exists on the blacklist.",
        description:
          "The following blacklist will quarantine any enquiry which has been sent from an IP address included in the blacklist.",
        add: "Add an IP address",
        createTitle: "Add an IP address to blacklist",
        inputDescription: "IP address",
        placeholder: "Enter IP address",
        confirmCreate: "Add",
      },
      URL: {
        title: "URLs",
        description:
          "The following control is used to help protect enquiry recipients from potential spam links included within an enquiry message. Once activated the control will quarantine any enquiry which includes a URL within the message text. This control will not quarantine the enquiry if the URL relates to an iProperty URL.",
        configDescription:
          "Quarantine all emails that contain URLs not associated with iProperty.com.my",
      },
    },
    operationTip: {
      RESEND: "Resent on",
      FORWARD: "Forwarded on",
      BLOCK: "Blocked on",
      RELEASE: "Released on",
    },
    enquiryTypeOption: {
      buy: "Buy",
      rent: "Rent",
      new: "New Launch",
      areaSpecialist: "Area specialist",
      condoSpecialist: "Condo specialist",
      agent: "Agent profile",
      developer: "Developer profile",
      servicedApartment: "Serviced apartment",
    },
    actionHistory: {
      RESEND: "Resent on",
      FORWARD: "Forwarded on",
      BLOCK: "Blacklisted on",
      RELEASE: "Released on",
    },
  },
};
